import React, { useState, useEffect } from 'react';
import {
  Container,
  Tabs,
  Tab,
  Box,
  Typography,
  IconButton,
  Tooltip
} from '@mui/material';
import {
  CheckCircle as ApproveIcon,
  Assignment as TaskIcon,
  Settings as AdminIcon,
  Refresh as RefreshIcon
} from '@mui/icons-material';
import PanelReferente from './PanelReferente';
import PanelRH from './PanelRH';
import PanelAdmin from './PanelAdmin';
import { apiRequest } from '../../utils/api';

function TabPanel({ children, value, index }) {
  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`admin-tabpanel-${index}`}
      sx={{
        display: value === index ? 'block' : 'none',
        width: '100%'
      }}
    >
      {children}
    </Box>
  );
}

function PanelAdminCompleto() {
  const [tabValue, setTabValue] = useState(0);
  const [refreshKey, setRefreshKey] = useState(0);
  // Optimista (true) hasta que se confirme, para no ocultar la solapa de
  // más y que después "aparezca" — solo se oculta si el backend confirma
  // que este usuario no es aprobador de RH.
  const [puedeAprobarRH, setPuedeAprobarRH] = useState(true);

  useEffect(() => {
    const verificarAprobadorRH = async () => {
      try {
        const data = await apiRequest('/api/auth/me');
        const esAprobador = data.rol === 'superadmin' || data.aprueba_vacaciones === true;
        setPuedeAprobarRH(esAprobador);
        setTabValue((actual) => (!esAprobador && actual === 1 ? 0 : actual));
      } catch (err) {
        console.error('Error al verificar si el usuario aprueba vacaciones:', err);
      }
    };
    verificarAprobadorRH();
  }, []);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleRefresh = () => {
    setRefreshKey(prev => prev + 1);
  };

  return (
    <Container maxWidth="xl" sx={{ py: 2 }}>
      <Box sx={{
        borderBottom: 1,
        borderColor: 'divider',
        mb: 3,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ flex: 1 }}
        >
          <Tab
            value={0}
            icon={<TaskIcon />}
            label="Pendientes de Referente"
            iconPosition="start"
          />
          {puedeAprobarRH && (
            <Tab
              value={1}
              icon={<ApproveIcon />}
              label="Pendientes de RH"
              iconPosition="start"
            />
          )}
          <Tab
            value={2}
            icon={<AdminIcon />}
            label="Gestión Administrativa"
            iconPosition="start"
          />
        </Tabs>

        <Tooltip title="Recargar solicitudes">
          <IconButton
            onClick={handleRefresh}
            color="primary"
            sx={{ ml: 2 }}
          >
            <RefreshIcon />
          </IconButton>
        </Tooltip>
      </Box>

      <TabPanel value={tabValue} index={0}>
        <PanelReferente key={`referente-${refreshKey}`} />
      </TabPanel>

      {puedeAprobarRH && (
        <TabPanel value={tabValue} index={1}>
          <PanelRH key={`rh-${refreshKey}`} />
        </TabPanel>
      )}

      <TabPanel value={tabValue} index={2}>
        <PanelAdmin key={`admin-${refreshKey}`} />
      </TabPanel>
    </Container>
  );
}

export default PanelAdminCompleto;
